export default {
  "home.heading.default": "залітай на дзвінок",
  "home.heading.loading": "Відкриваємо кімнату...",
  "home.heading.join": "готовий залетіти?",
  "home.heading.joined": "ти тут",
  "home.heading.pending": "чекаємо на хоста",
  "home.body.default": "створюй кімнату, кидай лінк, вайбуй.",
  "home.body.loading": "секунду, готуємо кімнату.",
  "home.body.join": "чекни камеру та мікро і залітай.",
  "home.body.joined": "кімната лайв. кидай лінк або просто починай.",
  "home.body.joined_in_room": "в кімнаті — залітай або кидай лінк.",
  "home.body.pending": "кімната закрита. хост тебе впустить.",
  "home.cta.create": "Створити кімнату",
  "home.cta.join": "Зайти в кімнату",
  "home.cta.enter": "Увійти",
  "home.cta.creating": "Створюємо...",
  "home.cta.joining": "Заходимо...",
  "home.cta.opening": "Відкриваємо...",
  "home.cta.pending": "Чекаємо на апрув...",
  "home.copy_link": "скопіювати лінк",
  "home.copied": "скопійовано!",
  "home.leave": "вийти з кімнати",
  "home.back": "назад",
  "home.no_participants": "тут поки нікого",
  "home.join_by_code": "зайти за кодом",
  "home.code_placeholder": "введи код",
  "home.name_placeholder": "твоє ім'я",
  "home.people_one": "людина",
  "home.people_other": "людей",
  "home.marketing.invite.title": "Створюй кімнату,\nкидай лінк.",
  "home.marketing.invite.body": "Один тап — і готово. Кидай лінк друзям, і будь-хто зможе зайти: без завантажень і реєстрацій.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Виглядай\nяк хочеш.",
  "home.marketing.look.body": "Корекція кольору, пом'якшення, віньєтка — або взагалі заблюр обличчя. Твоя камера, твій стиль.",
  "home.marketing.host.title": "Твій простір,\nтвої правила.",
  "home.marketing.host.body": "Закрий кімнату, зам'ють когось або взагалі кікни. Хост тут головний.",
  "home.marketing.host.locked": "Кімната закрита",
  "home.marketing.host.waiting_to_join": "Чекають на вхід",
  "home.marketing.host.wants_to_join": "хоче зайти",
  "home.marketing.anything.title": "Реально для будь-чого.",
  "home.marketing.anything.body": "Навчання, ігри, робочі стендапи, спільний перегляд фільмів — або просто посидіти.",
  "home.marketing.use_case.study_group": "📚 стаді-група",
  "home.marketing.use_case.game_night": "🎮 гейм-найт",
  "home.marketing.use_case.standup": "💼 стендап",
  "home.marketing.use_case.watch_party": "🍿 вотч-паті",
  "home.marketing.use_case.catch_up": "☕ кетчап",
  "home.marketing.use_case.jam_session": "🎸 джем-сесія",
  "home.marketing.use_case.book_club": "📖 книжковий клуб",
  "home.marketing.use_case.coworking": "💻 коворкінг",
  "ended.heading": "дзвінок завершено",
  "ended.left": "ти вийшов з кімнати.",
  "ended.room_ended": "{title} завершився для тебе.",
  "ended.rejoin": "зайти знову",
  "ended.rejoining": "повертаємось...",
  "ended.home": "на головну",
  "call.connecting": "з'єднуємо",
  "call.waiting": "чекаємо на інших",
  "call.invite_code": "код інвайту",
  "call.audio_on": "звук увімкнено",
  "call.muted": "в муті",
  "call.listening": "Слухає",
  "call.audio_muted": "Звук вимкнено",
  "call.speaking": "говорить",
  "call.you": "ти",
  "call.you_label": "Ти",
  "call.you_suffix": "(ти)",
  "call.chat_placeholder": "напиши щось...",
  "call.guest": "гість",
  "call.room_fallback": "кімната",
  "call.focus_view": "Фокус-режим",
  "call.grid_view": "Сітка",
  "call.swap_main_video": "Змінити головне відео",
  "call.open_chat": "Відкрити чат",
  "call.close_chat": "Закрити чат",
  "call.leave_room": "Вийти з кімнати",
  "call.confirm_leave": "Вийти?",
  "call.mic_on": "Мікро увімкнено",
  "call.muted_label": "Зам'ючено",
  "call.camera_off": "Камера вимкнена",
  "call.connect_failed": "Не вийшло підключитися — чекни інет і спробуй ще раз.",
  "call.camera_access_failed": "Немає доступу до камери. Чекни дозволи в браузері та спробуй ще.",
  "call.recording_failed": "Не вдалося почати запис. Дзвінок продовжиться без нього.",
  "call.initialize_failed": "Щось пішло не так під час запуску. Онови сторінку і спробуй ще.",
  "call.participants": "Учасники",
  "call.open_participants": "Відкрити учасників",
  "call.close_participants": "Закрити учасників",
  "call.lock_room": "Закрити кімнату",
  "call.unlock_room": "Відкрити кімнату",
  "call.locked": "закрита",
  "call.unlocked": "відкрита",
  "call.kick_member": "Кікнути з кімнати",
  "call.mute_member": "Зам'ютити",
  "call.unmute_member": "Розм'ютити",
  "call.muted_by_host": "Зам'ючено хостом",
  "call.waiting_to_join": "Чекають на вхід",
  "call.approve": "Впустити",
  "call.deny": "Відхилити",
  "call.profile_actions": "Дії з профілем",
  "call.profile_in_room": "В кімнаті",
  "call.profile_role_host": "Хост",
  "call.profile_role_you": "Ти",
  "call.profile_action_mute": "Зам'ютити їх",
  "call.profile_action_mute_meta": "Тільки для тебе — вони не дізнаються",
  "call.profile_action_dm": "DM",
  "call.profile_action_dm_meta": "Почати приватний чат",
  "call.profile_action_view": "Глянути фул профіль",
  "call.profile_action_view_meta": "Біо, мови, минулі сесії",
  "call.profile_action_report": "Репортнути",
  "call.profile_action_report_meta": "Відправити модераторам",
  "call.profile_sheet_close": "Закрити дії з профілем",
  "call.profile_open_actions": "Відкрити дії з профілем",
  "call.dm_title": "DM",
  "call.dm_back": "Назад до дій",
  "call.dm_close": "Закрити DM",
  "call.dm_status_online": "Онлайн",
  "call.dm_in_room_with": "У цій кімнаті",
  "call.dm_private_label": "Приватний чат",
  "call.dm_private_meta": "Ці повідомлення бачите тільки ви двоє",
  "call.dm_input_placeholder": "Написати в особисті…",
  "call.dm_send": "Надіслати",
  "call.dm_just_now": "зараз",
  "call.dm_seen_just_now": "Прочитано щойно",
  "call.dm_typing": "{name} друкує…",
  "call.dm_minimize": "Згорнути",
  "call.dm_active_indicator": "Відкрити чат",
  "call.dm_unread_messages": "{count} непрочитаних",
  "call.dm_toast_tap_to_open": "Тапни, щоб відкрити",
  "call.dm_reopen_aria": "Знову відкрити чат з {name}",
  "home.join_denied": "Хост тебе не впустив.",
  "home.error.room_not_found": "Такого коду кімнати не існує.",
  "home.error.profile_required": "Заповни профіль, щоб продовжити.",
  "home.cta.set_up_profile": "Заповнити профіль",
  "home.profile_trigger_new": "Тапни, щоб додати інфу про себе",
  "home.profile_trigger_new_aria": "Налаштувати профіль",
  "home.profile_trigger_edit_aria": "Редагувати профіль",
  "profile.eyebrow_new": "привітайся",
  "profile.eyebrow_edit": "твій профіль",
  "profile.title_new": "Розкажи про себе.",
  "profile.title_edit": "Редагувати профіль",
  "profile.subtitle": "Трохи інфи, щоб інші знали, з ким спілкуються.",
  "profile.add_photo": "Додати фото",
  "profile.add_photo_soon": "фото скоро будуть",
  "profile.photo_empty": "тапни, щоб додати фото",
  "profile.photo_ready": "фото готове",
  "profile.photo_save_first": "збережи профіль перед завантаженням фото",
  "profile.photo_crop_caption": "кадруй фото",
  "profile.photo_auto_caption": "посунь і наблизь, а ми збережемо автоматично",
  "profile.photo_upload": "Завантажити фото",
  "profile.photo_replace": "Замінити фото",
  "profile.photo_remove": "Видалити фото",
  "profile.photo_cancel": "Скасувати",
  "profile.photo_save": "Зберегти фото",
  "profile.photo_uploading": "Вантажимо фото…",
  "profile.photo_removing": "Видаляємо фото…",
  "profile.photo_choose_another": "Вибрати інше",
  "profile.photo_drag_hint": "Перетягни фото в коло. Зміни збережуться самі.",
  "profile.photo_zoom": "Зум",
  "profile.photo_horizontal": "По горизонталі",
  "profile.photo_vertical": "По вертикалі",
  "profile.name_label": "Ім'я",
  "profile.name_placeholder": "Як до тебе звертатися?",
  "profile.gender_label": "Я",
  "profile.gender.woman": "Жінка",
  "profile.gender.man": "Чоловік",
  "profile.gender.unspecified": "Не хочу казати",
  "profile.bio_label": "Біо",
  "profile.bio_optional": "опціонально",
  "profile.bio_placeholder": "Мови, які знаєш, що любиш, будь-що…",
  "profile.cta_new": "Погнали",
  "profile.cta_edit": "Зберегти зміни",
  "profile.saving": "Зберігаємо…",
  "profile.close": "Закрити",
  "profile.error.save_failed": "Не вийшло зберегти профіль. Спробуй ще.",
  "profile.error.avatar_invalid_type": "Вибери картинку у форматі PNG, JPEG, GIF або WebP.",
  "profile.error.avatar_too_large": "Вибери картинку до 5 МБ.",
  "profile.error.avatar_too_small": "Вибери картинку хоча б 96 на 96 пікселів.",
  "profile.error.avatar_load_failed": "Не змогли прочитати цю картинку. Спробуй інший файл.",
  "profile.error.avatar_failed": "Не вийшло завантажити фото. Спробуй ще.",
  "profile.error.avatar_remove_failed": "Не вийшло видалити фото. Спробуй ще.",
  "effects.title": "Ефекти",
  "effects.soft": "М'який фокус",
  "effects.vignette": "Віньєтка",
  "effects.face": "Блюр обличчя",
  "effects.face_preview_only": "Блюр обличчя (тільки прев'ю)",
  "effects.face_viewer_side": "Блюр обличчя (для глядачів)",
  "effects.face_strength": "Сила блюру",
  "effects.grade.off": "ВИМК",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "ТЕПЛО",
  "effects.grade.cool": "ХОЛОД",
  "effects.grade.bw": "ЧБ",
  "camera.off": "камера вимкнена",
  "camera.check": "чекни камеру",
  "camera.retry": "спробуй ще раз",
  "camera.ready": "камера готова",
  "camera.idle.title": "Увімкни камеру",
  "camera.idle.hint": "Ми запитаємо дозвіл у браузера, коли будеш готовий.",
  "camera.idle.button": "Увімкнути камеру",
  "camera.status.idle": "Чекаємо на тебе",
  "camera.status.off": "Камера вимкнена",
  "camera.status.loading": "Просимо доступ до камери...",
  "camera.status.denied": "Дай доступ до камери в браузері і спробуй ще.",
  "camera.status.error": "Не вийшло запустити прев'ю камери. Спробуй ще.",
  "camera.status.unsupported": "Цей браузер не підтримує доступ до камери.",
  "camera.status.insecure": "Для камери потрібен HTTPS або localhost.",
  "camera.status.attach_failed": "Прев'ю камери не запустилося. Спробуй ще.",
  "camera.guest_name_placeholder": "Ім'я гостя",
  "camera.flip": "Перемкнути камеру",
  "camera.save_name": "Зберегти",
  "camera.edit_name": "Змінити ім'я",
  "mic.on": "Вимкнути мікро",
  "mic.off": "Увімкнути мікро",
  "video.on": "Вимкнути камеру",
  "video.off": "Увімкнути камеру",
  "chat.title": "чат",
  "chat.close": "Закрити чат",
  "chat.loading": "вантажимо...",
  "chat.load_earlier": "завантажити старіші",
  "chat.empty": "поки немає повідомлень",
  "chat.send_error": "Повідомлення не надіслалося — спробуй ще.",
  "chat.input_placeholder": "напиши щось...",
  "room.host": "Хост",
  "app.room_default_title": "Створити кімнату",
  "app.chat_connection_rejected": "Чат не підключився — спробуй оновити сторінку.",
  "app.copy_failed": "Не вийшло скопіювати лінк. Спробуй виділити і скопіювати вручну.",
  "app.chat_not_connected": "Чат ще не підключився. Почекай секунду і спробуй ще.",
  "footer.terms": "Умови використання",
  "footer.copyright": "© 2026 Yano.AI"
}
